import React, {useLayoutEffect, useEffect, useState } from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import AddIcon from '@material-ui/icons/Add';
import IconButton from '@material-ui/core/IconButton';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { Button, Divider, Paper, Tab, Tabs, Box } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { allComplianceApprovalStatus } from '../app/globals';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {fetchApi} from '../app/utils/callApi';
import {fetchApi as fetchKycApi} from '../app/utils/callKycApi';

const useStyles = makeStyles(theme => ({
    topMargin: {
        marginTop: '64px',
        marginLeft: '1.7em',
        marginRight: '1.7em',
    },
    Title: {
        color: '#0c3336',
        marginBottom: '1em'
    },
    tabs: {
        backgroundColor: '#fff',
        marginBottom: '2em',
        borderBottom: '1px solid #e0e0e0'
    },
    tab: {
        textTransform: 'none',
        fontWeight: 600,
        '&.Mui-selected': {
            color: '#68d0af'
        }
    },
    tabIndicator: {
        backgroundColor: '#68d0af'
    },
    sectionTitle: {
        backgroundColor: '#0c3336',
        color: '#ffffff',
        padding: '0.5em 1em',
        marginTop: '1.5em',
        marginBottom: '1em',
        borderRadius: '4px'
    },
    subsectionTitle: {
        color: '#0c3336',
        fontWeight: 600,
        marginTop: '1.5em',
        marginBottom: '0.5em'
    },
    select: {
        '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: '2px solid #68d0af',
        }
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    circularProgress: {
        color: '#68d0af'
    },
    companyProfile: {
        margin: '2% auto',
        position: 'relative',
        maxWidth: '100%'
    },
    fieldLabel: {
        color: '#666',
        marginBottom: '0.3em',
        fontSize: '0.85rem'
    },
    ownerCard: {
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '1.5em',
        marginBottom: '1.5em',
        backgroundColor: '#fafafa'
    },
    ownerHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1em'
    },
    bankCard: {
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '1.5em',
        marginBottom: '1.5em',
        backgroundColor: '#fafafa'
    },
    saveButton: {
        position: 'fixed',
        bottom: '2em',
        right: '2em',
        zIndex: 1000
    },
    statusBadge: {
        display: 'inline-block',
        padding: '0.25em 0.75em',
        borderRadius: '4px',
        backgroundColor: '#f5f5f5',
        border: '1px solid #ddd',
        marginLeft: '1em',
        fontSize: '0.85rem'
    },
    noteBox: {
        backgroundColor: '#e8f5e9',
        border: '1px solid #c8e6c9',
        borderRadius: '4px',
        padding: '1em',
        marginBottom: '1.5em'
    },
    noteText: {
        color: '#2e7d32',
        margin: 0
    },
    hiddenInput: {
        display: 'none'
    },
    documentField: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5em',
        padding: '0.5em',
        backgroundColor: '#f5f5f5',
        borderRadius: '4px',
        marginTop: '0.5em'
    },
    documentName: {
        flex: 1,
        fontSize: '0.875rem',
        color: '#333'
    },
    documentActions: {
        display: 'flex',
        gap: '0.25em'
    }
}));

const OutlinedInputMod = withStyles({
    root: {
        '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#68d0af',
            borderWidth: '2px',
        },
    },
})(OutlinedInput);

const ButtonMod = withStyles({
    root: {
        marginRight: '1em',
        marginTop: '1em',
        backgroundColor: '#68d0af',
        color: '#ffffff',
        '&.MuiButton-root:hover': {
            backgroundColor: '#76e6c3'
        },
    },
})(Button);

const RedButton = withStyles({
    root: {
        backgroundColor: '#f44336',
        color: '#ffffff',
        '&.MuiButton-root:hover': {
            backgroundColor: '#d32f2f'
        },
    },
})(Button);

// Tab Panel component
function TabPanel({ children, value, index, ...other }) {
    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {value === index && <Box p={2}>{children}</Box>}
        </div>
    );
}

// Empty templates
const emptyPrimaryOwner = {
    firstName: '',
    lastName: '',
    dob: '',
    identification: '',
    gender: '',
    nationality: '',
    sharePercentage: '',
    country: '',
    address: { line1: '', line2: '', city: '', state: '', postal: '', country: '' }
};

const emptyBeneficialOwner = {
    isEntity: false,
    firstName: '',
    lastName: '',
    entityName: '',
    email: '',
    dob: '',
    identification: '',
    gender: '',
    nationality: '',
    sharePercentage: '',
    country: '',
    address: { line1: '', line2: '', city: '', state: '', postal: '', country: '' }
};

const emptyBank = {
    name: '',
    code: '',
    branch: '',
    swift: '',
    account: { name: '', number: '', currency: '' }
};

const emptyContact = {
    name: '',
    email: '',
    number: ''
};

const CompanySettings = (props) => {
    const classes = useStyles(props)
    const { openDrawer, toggleDrawer, organization, isLoading, getEnumeration, countries, mcc, currencies,
        fetchOrganization, patchOrganization, environment, setOrganizationLoading, setOrganizationNotLoading } = props

    const [tabValue, setTabValue] = useState(0);
    const [editableOrg, setEditableOrg] = useState({});
    const [hasChanges, setHasChanges] = useState(false);

    // Sync editable state with organization when it loads
    useEffect(() => {
        if (organization && organization.id) {
            const orgCopy = JSON.parse(JSON.stringify(organization));
            // Ensure nested objects exist
            if (!orgCopy.address) orgCopy.address = { line1: '', line2: '', city: '', state: '', postal: '', country: '' };
            if (!orgCopy.contact) orgCopy.contact = { ...emptyContact };
            if (!orgCopy.primaryOwner) orgCopy.primaryOwner = { ...emptyPrimaryOwner, address: { ...emptyPrimaryOwner.address } };
            if (!orgCopy.primaryOwner.address) orgCopy.primaryOwner.address = { line1: '', line2: '', city: '', state: '', postal: '', country: '' };
            if (!orgCopy.beneficialOwners) orgCopy.beneficialOwners = [];
            if (!orgCopy.banks) orgCopy.banks = [];
            if (!orgCopy.otherSupportingDocuments) orgCopy.otherSupportingDocuments = {};
            setEditableOrg(orgCopy);
            setHasChanges(false);
        }
    }, [organization]);

    useLayoutEffect(() => {
        if (!openDrawer) toggleDrawer()
        const urlArr = window.location.href.split('/')
        const orgID = urlArr[urlArr.length - 2]
        fetchOrganization({organizationId: orgID})
        getEnumeration({enumGroup: 'country'})
        getEnumeration({enumGroup: 'currency'})
        getEnumeration({enumGroup: 'mcc'})
    },[])

    // Download file from S3
    const downloadFile = (s3Key) => {
        if (!s3Key) return;
        setOrganizationLoading();
        fetchKycApi(environment,
            '/organizations/:organizationId/kycdoc',
            'get',
            { organizationId: editableOrg.id },
            null,
            { key: s3Key }
        ).then((result) => {
            setOrganizationNotLoading();
            const { data } = result;
            window.open(data, "_blank");
        }).catch(err => {
            setOrganizationNotLoading();
            alert('Error downloading file: ' + err.message);
        });
    };

    // Upload file to S3
    const uploadFile = (eventFile, fieldPath) => {
        const file = eventFile[0];
        if (!file) return;

        // Validate file type
        const allowedTypes = ['image/png', 'image/jpeg', 'image/heic', 'application/pdf'];
        if (!allowedTypes.includes(file.type)) {
            alert('Only PNG, JPEG, and PDF file types allowed');
            return;
        }

        // Validate file size (max 100MB)
        const maxSize = 102400 * 1000;
        if (file.size > maxSize) {
            alert('Maximum file size is 100MB');
            return;
        }

        setOrganizationLoading();

        // Get signed URL for upload
        fetchKycApi(environment,
            '/organizations/:organizationId/kycdoc',
            'post',
            { organizationId: editableOrg.id },
            {}
        ).then((result) => {
            const { data } = result;
            if (!data.url) {
                setOrganizationNotLoading();
                alert('Failed to get upload URL');
                return;
            }

            // Upload to S3
            const xhr = new XMLHttpRequest();
            xhr.open(data.method, data.url);
            xhr.setRequestHeader('x-amz-acl', data.XamzAcl);

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        // Update the field with file info
                        updateField(fieldPath, { name: file.name, key: data.key });
                        setOrganizationNotLoading();
                    } else {
                        setOrganizationNotLoading();
                        alert('Failed to upload file');
                    }
                }
            };

            xhr.send(file);
        }).catch(err => {
            setOrganizationNotLoading();
            alert('Error uploading file: ' + err.message);
        });
    };

    // Upload file for array fields (like certificates)
    const uploadFileToArray = (eventFile, arrayPath) => {
        const file = eventFile[0];
        if (!file) return;

        // Validate file type
        const allowedTypes = ['image/png', 'image/jpeg', 'image/heic', 'application/pdf'];
        if (!allowedTypes.includes(file.type)) {
            alert('Only PNG, JPEG, and PDF file types allowed');
            return;
        }

        setOrganizationLoading();

        fetchKycApi(environment,
            '/organizations/:organizationId/kycdoc',
            'post',
            { organizationId: editableOrg.id },
            {}
        ).then((result) => {
            const { data } = result;
            if (!data.url) {
                setOrganizationNotLoading();
                return;
            }

            const xhr = new XMLHttpRequest();
            xhr.open(data.method, data.url);
            xhr.setRequestHeader('x-amz-acl', data.XamzAcl);

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        // Add to array
                        setEditableOrg(prev => {
                            const updated = JSON.parse(JSON.stringify(prev));
                            const keys = arrayPath.split('.');
                            let obj = updated;
                            for (let i = 0; i < keys.length - 1; i++) {
                                if (!obj[keys[i]]) obj[keys[i]] = {};
                                obj = obj[keys[i]];
                            }
                            const arrayKey = keys[keys.length - 1];
                            if (!obj[arrayKey]) obj[arrayKey] = [];
                            obj[arrayKey].push({ name: file.name, key: data.key });
                            return updated;
                        });
                        setHasChanges(true);
                        setOrganizationNotLoading();
                    } else {
                        setOrganizationNotLoading();
                        alert('Failed to upload file');
                    }
                }
            };

            xhr.send(file);
        }).catch(err => {
            setOrganizationNotLoading();
            alert('Error uploading file: ' + err.message);
        });
    };

    // Remove file from array
    const removeFileFromArray = (arrayPath, index) => {
        setEditableOrg(prev => {
            const updated = JSON.parse(JSON.stringify(prev));
            const keys = arrayPath.split('.');
            let obj = updated;
            for (let i = 0; i < keys.length - 1; i++) {
                if (!obj[keys[i]]) return prev;
                obj = obj[keys[i]];
            }
            const arrayKey = keys[keys.length - 1];
            if (obj[arrayKey]) {
                obj[arrayKey].splice(index, 1);
            }
            return updated;
        });
        setHasChanges(true);
    };

    // Render document field with upload/download
    const renderDocumentField = (label, fileData, fieldPath, inputId) => (
        <Grid item md={6} xs={12} sm={6}>
            <Typography className={classes.fieldLabel}>{label}</Typography>
            <div className={classes.documentField}>
                {fileData?.name ? (
                    <>
                        <span className={classes.documentName}>{fileData.name}</span>
                        <div className={classes.documentActions}>
                            {fileData.key && (
                                <IconButton size="small" onClick={() => downloadFile(fileData.key)} title="Download">
                                    <CloudDownloadIcon fontSize="small" />
                                </IconButton>
                            )}
                            <input
                                className={classes.hiddenInput}
                                id={inputId}
                                type="file"
                                onChange={(e) => uploadFile(e.target.files, fieldPath)}
                            />
                            <label htmlFor={inputId}>
                                <IconButton size="small" component="span" title="Replace">
                                    <CloudUploadIcon fontSize="small" />
                                </IconButton>
                            </label>
                        </div>
                    </>
                ) : (
                    <>
                        <span className={classes.documentName} style={{ color: '#999' }}>No file uploaded</span>
                        <input
                            className={classes.hiddenInput}
                            id={inputId}
                            type="file"
                            onChange={(e) => uploadFile(e.target.files, fieldPath)}
                        />
                        <label htmlFor={inputId}>
                            <IconButton size="small" component="span" title="Upload">
                                <CloudUploadIcon fontSize="small" />
                            </IconButton>
                        </label>
                    </>
                )}
            </div>
        </Grid>
    );

    // Generic field update handler
    const updateField = (path, value) => {
        setEditableOrg(prev => {
            const updated = JSON.parse(JSON.stringify(prev));
            const keys = path.split('.');
            let obj = updated;
            for (let i = 0; i < keys.length - 1; i++) {
                if (!obj[keys[i]]) obj[keys[i]] = {};
                obj = obj[keys[i]];
            }
            obj[keys[keys.length - 1]] = value;
            return updated;
        });
        setHasChanges(true);
    };

    // Beneficial owner handlers
    const addBeneficialOwner = () => {
        setEditableOrg(prev => {
            const updated = JSON.parse(JSON.stringify(prev));
            if (!updated.beneficialOwners) updated.beneficialOwners = [];
            updated.beneficialOwners.push({ ...emptyBeneficialOwner, address: { ...emptyBeneficialOwner.address } });
            return updated;
        });
        setHasChanges(true);
    };

    const removeBeneficialOwner = (index) => {
        setEditableOrg(prev => {
            const updated = JSON.parse(JSON.stringify(prev));
            updated.beneficialOwners.splice(index, 1);
            return updated;
        });
        setHasChanges(true);
    };

    const updateBeneficialOwner = (index, path, value) => {
        setEditableOrg(prev => {
            const updated = JSON.parse(JSON.stringify(prev));
            const keys = path.split('.');
            let obj = updated.beneficialOwners[index];
            for (let i = 0; i < keys.length - 1; i++) {
                if (!obj[keys[i]]) obj[keys[i]] = {};
                obj = obj[keys[i]];
            }
            obj[keys[keys.length - 1]] = value;
            return updated;
        });
        setHasChanges(true);
    };

    // Bank handlers
    const addBank = () => {
        setEditableOrg(prev => {
            const updated = JSON.parse(JSON.stringify(prev));
            if (!updated.banks) updated.banks = [];
            updated.banks.push({ ...emptyBank, account: { ...emptyBank.account } });
            return updated;
        });
        setHasChanges(true);
    };

    const removeBank = (index) => {
        setEditableOrg(prev => {
            const updated = JSON.parse(JSON.stringify(prev));
            updated.banks.splice(index, 1);
            return updated;
        });
        setHasChanges(true);
    };

    const updateBank = (index, path, value) => {
        setEditableOrg(prev => {
            const updated = JSON.parse(JSON.stringify(prev));
            const keys = path.split('.');
            let obj = updated.banks[index];
            for (let i = 0; i < keys.length - 1; i++) {
                if (!obj[keys[i]]) obj[keys[i]] = {};
                obj = obj[keys[i]];
            }
            obj[keys[keys.length - 1]] = value;
            return updated;
        });
        setHasChanges(true);
    };

    // Save all changes
    const handleSaveAll = async () => {
        if (!editableOrg.id) {
            alert('NO ORGANIZATION ID');
            return;
        }

        // Clean up primaryOwner - convert sharePercentage to number
        const cleanPrimaryOwner = editableOrg.primaryOwner ? {
            ...editableOrg.primaryOwner,
            sharePercentage: editableOrg.primaryOwner.sharePercentage
                ? parseFloat(editableOrg.primaryOwner.sharePercentage)
                : undefined
        } : undefined;

        // Clean up beneficialOwners - convert sharePercentage to number for each
        const cleanBeneficialOwners = editableOrg.beneficialOwners
            ? editableOrg.beneficialOwners.map(owner => ({
                ...owner,
                sharePercentage: owner.sharePercentage
                    ? parseFloat(owner.sharePercentage)
                    : undefined
            }))
            : [];

        const updatePayload = {
            name: editableOrg.name,
            dba: editableOrg.dba,
            uen: editableOrg.uen,
            description: editableOrg.description,
            website: editableOrg.website,
            type: editableOrg.type,
            mcc: editableOrg.mcc,
            country: editableOrg.country,
            publicListed: editableOrg.publicListed,
            address: editableOrg.address,
            contact: editableOrg.contact,
            primaryOwner: cleanPrimaryOwner,
            beneficialOwners: cleanBeneficialOwners,
            banks: editableOrg.banks,
            // Document fields
            bizRegCert: editableOrg.bizRegCert,
            articleOfAssociation: editableOrg.articleOfAssociation,
            otherSupportingDocuments: editableOrg.otherSupportingDocuments
        };
        try {
            await patchOrganization({ organizationId: editableOrg.id }, updatePayload);
            // Refetch to ensure we have the latest data from the server
            await fetchOrganization({ organizationId: editableOrg.id });
            setHasChanges(false);
        } catch (error) {
            console.error('Error saving:', error);
            alert('Error saving changes: ' + error.message);
        }
    };

    // Render input field helper
    const renderField = (label, value, onChange, placeholder = '', type = 'text', fullWidth = false) => (
        <Grid item md={fullWidth ? 12 : 6} xs={12} sm={fullWidth ? 12 : 6}>
            <Typography className={classes.fieldLabel}>{label}</Typography>
            <OutlinedInputMod
                fullWidth
                type={type}
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder || label}
            />
        </Grid>
    );

    // Render select field helper
    const renderSelect = (label, value, onChange, options, valueKey, labelKey) => (
        <Grid item md={6} xs={12} sm={6}>
            <Typography className={classes.fieldLabel}>{label}</Typography>
            <Select
                fullWidth
                variant="outlined"
                className={classes.select}
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
            >
                <MenuItem value="">Select {label}</MenuItem>
                {options.map((opt, idx) => (
                    <MenuItem key={idx} value={valueKey ? opt.value[valueKey] : opt.value}>
                        {labelKey ? opt[labelKey] || opt.name : opt.name}
                    </MenuItem>
                ))}
            </Select>
        </Grid>
    );

    return (
    <main className={classes.topMargin}>
        <Backdrop className={classes.backdrop} open={isLoading}>
            <CircularProgress className={classes.circularProgress} />
        </Backdrop>

        {/* Header */}
        <Typography variant="h4" className={classes.Title}>
            Settings
            <span className={classes.statusBadge}>
                {editableOrg.complianceApproval || 'NO_STATUS'}
            </span>
        </Typography>

        {/* Tabs */}
        <Paper className={classes.tabs} elevation={0}>
            <Tabs
                value={tabValue}
                onChange={(e, newValue) => setTabValue(newValue)}
                classes={{ indicator: classes.tabIndicator }}
            >
                <Tab label="GENERAL" className={classes.tab} />
                <Tab label="OWNERS" className={classes.tab} />
                <Tab label="BANK DETAILS" className={classes.tab} />
                <Tab label="OTHER SUPPORTING DOCUMENTS" className={classes.tab} />
            </Tabs>
        </Paper>

        {/* Tab Panels */}
        <Container maxWidth="lg">
            {/* GENERAL Tab */}
            <TabPanel value={tabValue} index={0}>
                <div className={classes.noteBox}>
                    <Typography className={classes.noteText}>
                        <strong>NOTE:</strong> When you're done completing the General, Owners, Bank Details, and Other Supporting Documents, click "SAVE ALL CHANGES" at the bottom.
                    </Typography>
                </div>

                <Grid container spacing={2}>
                    {renderField('Company Legal Business Name', editableOrg.name, (v) => updateField('name', v))}
                    <Grid item md={6} xs={12} sm={6}>
                        <Typography className={classes.fieldLabel}>Public Listed</Typography>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={editableOrg.publicListed || false}
                                    onChange={(e) => updateField('publicListed', e.target.checked)}
                                    color="primary"
                                />
                            }
                            label={editableOrg.publicListed ? 'Yes' : 'No'}
                        />
                    </Grid>
                    <Grid item md={6} xs={12} sm={6}>
                        <Typography className={classes.fieldLabel}>ID</Typography>
                        <Typography color="textSecondary">{editableOrg.id}</Typography>
                    </Grid>
                    {renderSelect('Country Based In', editableOrg.country, (v) => updateField('country', v), countries, 'country_alpha3_code', 'name')}
                    {renderField('UEN (Unique Entity Number)', editableOrg.uen, (v) => updateField('uen', v))}
                    {renderSelect('Type', editableOrg.type, (v) => updateField('type', v), [
                        { name: 'Private Limited Company', value: 'Private Limited Company' },
                        { name: 'Public Limited Company', value: 'Public Limited Company' },
                        { name: 'Sole Proprietorship', value: 'Sole Proprietorship' },
                        { name: 'Partnership', value: 'Partnership' },
                        { name: 'Limited Liability Partnership', value: 'Limited Liability Partnership' },
                    ], null, 'name')}
                    {renderField('Doing Business As', editableOrg.dba, (v) => updateField('dba', v))}
                    {renderField('Business Website', editableOrg.website, (v) => updateField('website', v))}
                    {renderSelect('Industry (MCC)', editableOrg.mcc, (v) => updateField('mcc', v), mcc, 'code', 'name')}
                    {renderField('Business Description', editableOrg.description, (v) => updateField('description', v), '', 'text', true)}
                </Grid>

                <Typography className={classes.subsectionTitle}>Business Documents</Typography>
                <Grid container spacing={2}>
                    {renderDocumentField('Business Registration Certificate', editableOrg.bizRegCert, 'bizRegCert', 'bizRegCert-upload')}
                    {renderDocumentField('Article of Association', editableOrg.articleOfAssociation, 'articleOfAssociation', 'articleOfAssociation-upload')}
                </Grid>

                <Typography className={classes.subsectionTitle}>Business Address</Typography>
                <Grid container spacing={2}>
                    {renderField('Address Line 1', editableOrg.address?.line1, (v) => updateField('address.line1', v))}
                    {renderField('Address Line 2', editableOrg.address?.line2, (v) => updateField('address.line2', v))}
                    {renderField('City', editableOrg.address?.city, (v) => updateField('address.city', v))}
                    {renderField('State/Province', editableOrg.address?.state, (v) => updateField('address.state', v))}
                    {renderField('Postal Code', editableOrg.address?.postal, (v) => updateField('address.postal', v))}
                    {renderSelect('Country', editableOrg.address?.country, (v) => updateField('address.country', v), countries, 'country_alpha3_code', 'name')}
                </Grid>

                <Typography className={classes.subsectionTitle}>Contact Information</Typography>
                <Grid container spacing={2}>
                    {renderField('Contact Name', editableOrg.contact?.name, (v) => updateField('contact.name', v))}
                    {renderField('Contact Email', editableOrg.contact?.email, (v) => updateField('contact.email', v))}
                    {renderField('Contact Phone Number', editableOrg.contact?.number, (v) => updateField('contact.number', v))}
                </Grid>
            </TabPanel>

            {/* OWNERS Tab */}
            <TabPanel value={tabValue} index={1}>
                <Typography color="textSecondary" gutterBottom>
                    This account must be activated by someone authorized to sign on behalf of the organization.
                </Typography>

                {/* Primary Owner */}
                <Typography variant="h6" className={classes.sectionTitle}>Primary Owner Details</Typography>
                <div className={classes.ownerCard}>
                    <Grid container spacing={2}>
                        {renderField('First Name', editableOrg.primaryOwner?.firstName, (v) => updateField('primaryOwner.firstName', v))}
                        {renderField('Last Name', editableOrg.primaryOwner?.lastName, (v) => updateField('primaryOwner.lastName', v))}
                        {renderField('Share Percentage (%)', editableOrg.primaryOwner?.sharePercentage, (v) => updateField('primaryOwner.sharePercentage', v), '0-100')}
                        <Grid item md={6} xs={12} sm={6}>
                            <Typography className={classes.fieldLabel}>Gender</Typography>
                            <Select
                                fullWidth
                                variant="outlined"
                                className={classes.select}
                                value={editableOrg.primaryOwner?.gender || ''}
                                onChange={(e) => updateField('primaryOwner.gender', e.target.value)}
                            >
                                <MenuItem value="">Select Gender</MenuItem>
                                <MenuItem value="male">Male</MenuItem>
                                <MenuItem value="female">Female</MenuItem>
                                <MenuItem value="other">Other</MenuItem>
                            </Select>
                        </Grid>
                        {renderSelect('Nationality', editableOrg.primaryOwner?.nationality, (v) => updateField('primaryOwner.nationality', v), countries, 'country_alpha3_code', 'name')}
                        {renderField('Date of Birth', editableOrg.primaryOwner?.dob, (v) => updateField('primaryOwner.dob', v), 'YYYY-MM-DD', 'date')}
                        {renderField('Identification Number', editableOrg.primaryOwner?.identification, (v) => updateField('primaryOwner.identification', v))}
                        {renderSelect('Country Based In', editableOrg.primaryOwner?.country, (v) => updateField('primaryOwner.country', v), countries, 'country_alpha3_code', 'name')}
                    </Grid>

                    <Typography className={classes.subsectionTitle}>Primary Owner Address</Typography>
                    <Grid container spacing={2}>
                        {renderField('Address Line 1', editableOrg.primaryOwner?.address?.line1, (v) => updateField('primaryOwner.address.line1', v))}
                        {renderField('Address Line 2', editableOrg.primaryOwner?.address?.line2, (v) => updateField('primaryOwner.address.line2', v))}
                        {renderField('City', editableOrg.primaryOwner?.address?.city, (v) => updateField('primaryOwner.address.city', v))}
                        {renderField('Postal Code', editableOrg.primaryOwner?.address?.postal, (v) => updateField('primaryOwner.address.postal', v))}
                        {renderSelect('Country', editableOrg.primaryOwner?.address?.country, (v) => updateField('primaryOwner.address.country', v), countries, 'country_alpha3_code', 'name')}
                    </Grid>

                    <Typography className={classes.subsectionTitle}>Primary Owner Documents</Typography>
                    <Grid container spacing={2}>
                        {renderDocumentField('Proof of Identification', editableOrg.primaryOwner?.proofOfIdentification, 'primaryOwner.proofOfIdentification', 'primaryOwner-proofOfId-upload')}
                        {renderDocumentField('Proof of Address', editableOrg.primaryOwner?.proofOfAddress, 'primaryOwner.proofOfAddress', 'primaryOwner-proofOfAddress-upload')}
                    </Grid>
                </div>

                {/* Beneficial Owners */}
                <Typography variant="h6" className={classes.sectionTitle}>
                    Additional Beneficial Owners
                    <IconButton size="small" onClick={addBeneficialOwner} style={{ color: '#fff', marginLeft: '1em' }}>
                        <AddIcon />
                    </IconButton>
                </Typography>
                <Typography color="textSecondary" gutterBottom style={{ marginBottom: '1em' }}>
                    Please list all other beneficial owners. Beneficial owners are individuals who own more than 20% of the business,
                    or are in the position to exercise significant control over the business's finances and operations (CEO, CFO, COO, or similar).
                </Typography>

                {editableOrg.beneficialOwners && editableOrg.beneficialOwners.map((owner, index) => (
                    <div key={index} className={classes.ownerCard}>
                        <div className={classes.ownerHeader}>
                            <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                                Beneficial Owner #{index + 1}
                            </Typography>
                            <RedButton size="small" onClick={() => removeBeneficialOwner(index)}>
                                <DeleteOutlineIcon /> Remove
                            </RedButton>
                        </div>

                        <Grid container spacing={2}>
                            <Grid item md={12} xs={12}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={owner.isEntity || false}
                                            onChange={(e) => updateBeneficialOwner(index, 'isEntity', e.target.checked)}
                                            color="primary"
                                        />
                                    }
                                    label="Is this beneficial owner a company?"
                                />
                            </Grid>

                            {owner.isEntity ? (
                                <>
                                    {renderField('Entity Name', owner.entityName, (v) => updateBeneficialOwner(index, 'entityName', v))}
                                    {renderField('Registration Number', owner.identification, (v) => updateBeneficialOwner(index, 'identification', v))}
                                    {renderField('Share Percentage (%)', owner.sharePercentage, (v) => updateBeneficialOwner(index, 'sharePercentage', v), '0-100')}
                                </>
                            ) : (
                                <>
                                    {renderField('First Name', owner.firstName, (v) => updateBeneficialOwner(index, 'firstName', v))}
                                    {renderField('Last Name', owner.lastName, (v) => updateBeneficialOwner(index, 'lastName', v))}
                                    {renderField('Email', owner.email, (v) => updateBeneficialOwner(index, 'email', v))}
                                    {renderField('Date of Birth', owner.dob, (v) => updateBeneficialOwner(index, 'dob', v), 'YYYY-MM-DD', 'date')}
                                    <Grid item md={6} xs={12} sm={6}>
                                        <Typography className={classes.fieldLabel}>Gender</Typography>
                                        <Select
                                            fullWidth
                                            variant="outlined"
                                            className={classes.select}
                                            value={owner.gender || ''}
                                            onChange={(e) => updateBeneficialOwner(index, 'gender', e.target.value)}
                                        >
                                            <MenuItem value="">Select Gender</MenuItem>
                                            <MenuItem value="male">Male</MenuItem>
                                            <MenuItem value="female">Female</MenuItem>
                                            <MenuItem value="other">Other</MenuItem>
                                        </Select>
                                    </Grid>
                                    {renderSelect('Nationality', owner.nationality, (v) => updateBeneficialOwner(index, 'nationality', v), countries, 'country_alpha3_code', 'name')}
                                    {renderField('Share Percentage (%)', owner.sharePercentage, (v) => updateBeneficialOwner(index, 'sharePercentage', v), '0-100')}
                                    {renderSelect('Country Based In', owner.country, (v) => updateBeneficialOwner(index, 'country', v), countries, 'country_alpha3_code', 'name')}
                                    {renderField('Identification Number', owner.identification, (v) => updateBeneficialOwner(index, 'identification', v))}
                                </>
                            )}
                        </Grid>

                        {!owner.isEntity && (
                            <>
                                <Typography className={classes.subsectionTitle}>Address</Typography>
                                <Grid container spacing={2}>
                                    {renderField('Address Line 1', owner.address?.line1, (v) => updateBeneficialOwner(index, 'address.line1', v))}
                                    {renderField('Address Line 2', owner.address?.line2, (v) => updateBeneficialOwner(index, 'address.line2', v))}
                                    {renderField('City', owner.address?.city, (v) => updateBeneficialOwner(index, 'address.city', v))}
                                    {renderField('Postal Code', owner.address?.postal, (v) => updateBeneficialOwner(index, 'address.postal', v))}
                                    {renderSelect('Country', owner.address?.country, (v) => updateBeneficialOwner(index, 'address.country', v), countries, 'country_alpha3_code', 'name')}
                                </Grid>
                            </>
                        )}
                    </div>
                ))}

                {(!editableOrg.beneficialOwners || editableOrg.beneficialOwners.length === 0) && (
                    <Typography color="textSecondary" style={{ marginTop: '1em' }}>
                        No additional beneficial owners added. Click the + button above to add one.
                    </Typography>
                )}
            </TabPanel>

            {/* BANK DETAILS Tab */}
            <TabPanel value={tabValue} index={2}>
                <Typography variant="h6" className={classes.sectionTitle}>
                    Your Bank Details
                    <IconButton size="small" onClick={addBank} style={{ color: '#fff', marginLeft: '1em' }}>
                        <AddIcon />
                    </IconButton>
                </Typography>

                {editableOrg.banks && editableOrg.banks.map((bank, index) => (
                    <div key={index} className={classes.bankCard}>
                        <div className={classes.ownerHeader}>
                            <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                                Bank #{index + 1}
                            </Typography>
                            <RedButton size="small" onClick={() => removeBank(index)}>
                                <DeleteOutlineIcon /> Remove
                            </RedButton>
                        </div>

                        <Grid container spacing={2}>
                            {renderField('Bank Name', bank.name, (v) => updateBank(index, 'name', v))}
                            {renderField('Bank Code', bank.code, (v) => updateBank(index, 'code', v))}
                            {renderField('Bank Branch Code', bank.branch, (v) => updateBank(index, 'branch', v))}
                            {renderField('Bank Swift Code', bank.swift, (v) => updateBank(index, 'swift', v))}
                            {renderField('Account Name', bank.account?.name, (v) => updateBank(index, 'account.name', v))}
                            {renderField('Account Number', bank.account?.number, (v) => updateBank(index, 'account.number', v))}
                            {renderSelect('Account Currency', bank.account?.currency, (v) => updateBank(index, 'account.currency', v), currencies, 'currency_alpha3_code', 'name')}
                            {renderDocumentField('Bank Statement', bank.bankStatement, `banks.${index}.bankStatement`, `bank-${index}-statement-upload`)}
                        </Grid>
                    </div>
                ))}

                {(!editableOrg.banks || editableOrg.banks.length === 0) && (
                    <Typography color="textSecondary" style={{ marginTop: '1em' }}>
                        No bank accounts added. Click the + button above to add one.
                    </Typography>
                )}
            </TabPanel>

            {/* OTHER SUPPORTING DOCUMENTS Tab */}
            <TabPanel value={tabValue} index={3}>
                <Typography variant="h6" className={classes.sectionTitle}>Other Supporting Documents</Typography>

                {/* Business Documents - same as General tab but with download/upload */}
                <div className={classes.ownerCard}>
                    <Grid container spacing={2}>
                        {renderDocumentField('Business Registration Certificate', editableOrg.bizRegCert, 'bizRegCert', 'supp-bizRegCert-upload')}
                        {renderDocumentField('Article of Association', editableOrg.articleOfAssociation, 'articleOfAssociation', 'supp-articleOfAssociation-upload')}
                    </Grid>
                </div>

                {/* Certificates */}
                <div className={classes.ownerCard}>
                    <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '1em' }}>
                        Licenses / Certificates
                        <input
                            className={classes.hiddenInput}
                            id="certificates-upload"
                            type="file"
                            onChange={(e) => uploadFileToArray(e.target.files, 'otherSupportingDocuments.certificates')}
                        />
                        <label htmlFor="certificates-upload">
                            <IconButton size="small" component="span" title="Add Certificate" style={{ marginLeft: '0.5em' }}>
                                <AddIcon fontSize="small" />
                            </IconButton>
                        </label>
                    </Typography>
                    {editableOrg.otherSupportingDocuments?.certificates && editableOrg.otherSupportingDocuments.certificates.length > 0 ? (
                        editableOrg.otherSupportingDocuments.certificates.map((cert, idx) => (
                            <div key={idx} className={classes.documentField} style={{ marginBottom: '0.5em' }}>
                                <span className={classes.documentName}>{cert.name}</span>
                                <div className={classes.documentActions}>
                                    {cert.key && (
                                        <IconButton size="small" onClick={() => downloadFile(cert.key)} title="Download">
                                            <CloudDownloadIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                    <IconButton size="small" onClick={() => removeFileFromArray('otherSupportingDocuments.certificates', idx)} title="Remove" style={{ color: '#f44336' }}>
                                        <DeleteOutlineIcon fontSize="small" />
                                    </IconButton>
                                </div>
                            </div>
                        ))
                    ) : (
                        <Typography color="textSecondary">No certificates uploaded. Click + to add.</Typography>
                    )}
                </div>

                {/* Previous Processings */}
                <div className={classes.ownerCard}>
                    <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '1em' }}>
                        Previous Processing Statements
                        <input
                            className={classes.hiddenInput}
                            id="previousProcessings-upload"
                            type="file"
                            onChange={(e) => uploadFileToArray(e.target.files, 'otherSupportingDocuments.previousProcessings')}
                        />
                        <label htmlFor="previousProcessings-upload">
                            <IconButton size="small" component="span" title="Add Document" style={{ marginLeft: '0.5em' }}>
                                <AddIcon fontSize="small" />
                            </IconButton>
                        </label>
                    </Typography>
                    {editableOrg.otherSupportingDocuments?.previousProcessings && editableOrg.otherSupportingDocuments.previousProcessings.length > 0 ? (
                        editableOrg.otherSupportingDocuments.previousProcessings.map((doc, idx) => (
                            <div key={idx} className={classes.documentField} style={{ marginBottom: '0.5em' }}>
                                <span className={classes.documentName}>{doc.name}</span>
                                <div className={classes.documentActions}>
                                    {doc.key && (
                                        <IconButton size="small" onClick={() => downloadFile(doc.key)} title="Download">
                                            <CloudDownloadIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                    <IconButton size="small" onClick={() => removeFileFromArray('otherSupportingDocuments.previousProcessings', idx)} title="Remove" style={{ color: '#f44336' }}>
                                        <DeleteOutlineIcon fontSize="small" />
                                    </IconButton>
                                </div>
                            </div>
                        ))
                    ) : (
                        <Typography color="textSecondary">No previous processing statements uploaded. Click + to add.</Typography>
                    )}
                </div>
            </TabPanel>

            {/* Spacer for fixed save button */}
            <div style={{ height: '100px' }} />
        </Container>

        {/* Fixed Save Button */}
        {hasChanges && (
            <div className={classes.saveButton}>
                <ButtonMod
                    variant="contained"
                    size="large"
                    onClick={handleSaveAll}
                    style={{ padding: '1em 3em', fontSize: '1.1rem' }}
                >
                    SAVE ALL CHANGES
                </ButtonMod>
            </div>
        )}
    </main>
    )
}

export default CompanySettings
